// @flow

import styled from 'styled-components';
import { BRAND_PURPLE } from '../brand';
import {
  SpinnerContainer as BaseSpinnerContainer,
  Spinner as BaseSpinner,
} from '@tectonics/features/jornada-sem-redirecionamento/pix-enrollment/screens/polling-auth-screen.styles';

export const SpinnerContainer = styled(BaseSpinnerContainer)`
  flex: 1;
  min-height: 0;
`;

export const Spinner = styled(BaseSpinner)`
  border-top-color: ${BRAND_PURPLE};
`;
